module.exports = __webpack_public_path__ + "static/media/PM57.10ee5449.JPG";